export function isUserPinned(state, id) {
    if (id) {
        return state['features/inklusiva/pinneduser'].pinnedParticipants.includes(id);
    }
    return false;
}
